import { Link, NavLink } from "react-router-dom";
import { Shield, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/AuthContext";
import { siteNav } from "@/content/siteContent";

export default function PublicHeader() {
  const { user } = useAuth();

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200/70 bg-white/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 md:px-8">
        <Link to="/" className="flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-[#0f172a] text-white shadow-lg shadow-slate-900/10">
            <Shield className="h-5 w-5" strokeWidth={2} />
          </div>
          <div>
            <div className="font-display text-xl font-black text-slate-950">Audit Pro</div>
            <div className="text-[10px] uppercase tracking-[0.28em] text-slate-500">Compliance orchestration</div>
          </div>
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {siteNav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `text-sm font-medium transition-colors ${isActive ? "text-slate-950" : "text-slate-500 hover:text-slate-950"}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          {user ? (
            <Link to="/app" className="hidden rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-700 transition-colors hover:border-slate-300 hover:text-slate-950 md:inline-flex">
              Apri app
            </Link>
          ) : null}
          <Button asChild variant="ghost" className="hidden text-slate-600 hover:text-slate-950 md:inline-flex">
            <Link to="/auth/login">Accedi</Link>
          </Button>
          <Button asChild className="rounded-full bg-[#0f172a] px-5 hover:bg-slate-800">
            <Link to={user ? "/app" : "/pricing"}>
              {user ? "Apri la piattaforma" : "Vedi i piani"} <ArrowRight className="h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </header>
  );
}
